module.exports = __webpack_public_path__ + "h5/img/logo.d7d4733b.png";